import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, map, withLatestFrom } from 'rxjs';
import { ChatAdapterActions } from '../state/chat/chat.actions';
import { AuthActions } from '../state/auth/auth.actions';
import { OrganizationActions } from '../state/organization/organization.actions';
import { organizationFeature } from '../state/organization/organization.feature';
import { userFeature } from '../state/user/user.feature';
import { userSettingsFeature } from '../state/user-settings/user-settings.feature';
import { permissionsFeature } from '../state/permissions/permissions.feature';
import { PermissionsActions } from '../state/permissions/premissions.actions';

// Matrix receives the org only after the same required-data barrier used by Panic.
export const connectMatrixOrganization = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(
        AuthActions.requiredDataLoadedSuccess,
        AuthActions.organizationDataLoadedSuccess,
        OrganizationActions.setActiveOrganization,
        OrganizationActions.setSwitchedActiveOrganization,
        PermissionsActions.getUserPermissionsSuccess,
        PermissionsActions.getUserPermissionsFail,
      ),
      withLatestFrom(
        store.select(organizationFeature.selectActiveOrganization),
        store.select(userFeature.selectLoaded),
        store.select(userSettingsFeature.selectLoaded),
        store.select(permissionsFeature.selectLoaded),
      ),
      filter(
        ([, organization, userLoaded, settingsLoaded, permissionsLoaded]) =>
          !!organization && userLoaded && settingsLoaded && permissionsLoaded,
      ),
      map(([, organization]) => organization!._id),
      distinctUntilChanged(),
      map((organizationId) =>
        ChatAdapterActions.setActiveOrganization({
          activeOrganization: { orgId: organizationId },
        }),
      ),
    ),
  { functional: true },
);
